import { render, staticRenderFns } from "./WeiboList.vue?vue&type=template&id=71edaa1a&scoped=true&"
import script from "./WeiboList.vue?vue&type=script&lang=js&"
export * from "./WeiboList.vue?vue&type=script&lang=js&"
import style0 from "./WeiboList.vue?vue&type=style&index=0&id=71edaa1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71edaa1a",
  null
  
)

export default component.exports